var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.69997V15.7M7.5 7.69997V15.7M12.5 7.69997V15.7M17 7.69997V15.7M1 17.3L1 18.1C1 18.66 1 18.94 1.10899 19.154C1.20487 19.3421 1.35785 19.4951 1.54601 19.591C1.75992 19.7 2.03995 19.7 2.6 19.7H17.4C17.9601 19.7 18.2401 19.7 18.454 19.591C18.6422 19.4951 18.7951 19.3421 18.891 19.154C19 18.94 19 18.66 19 18.1V17.3C19 16.7399 19 16.4599 18.891 16.246C18.7951 16.0578 18.6422 15.9048 18.454 15.809C18.2401 15.7 17.9601 15.7 17.4 15.7H2.6C2.03995 15.7 1.75992 15.7 1.54601 15.809C1.35785 15.9048 1.20487 16.0578 1.10899 16.246C1 16.4599 1 16.7399 1 17.3ZM9.65291 1.7771L2.25291 3.42155C1.80585 3.52089 1.58232 3.57057 1.41546 3.69077C1.26829 3.7968 1.15273 3.94087 1.08115 4.10754C1 4.2965 1 4.52548 1 4.98345L1 6.09997C1 6.66002 1 6.94005 1.10899 7.15396C1.20487 7.34212 1.35785 7.4951 1.54601 7.59098C1.75992 7.69997 2.03995 7.69997 2.6 7.69997H17.4C17.9601 7.69997 18.2401 7.69997 18.454 7.59098C18.6422 7.4951 18.7951 7.34212 18.891 7.15396C19 6.94005 19 6.66002 19 6.09997V4.98345C19 4.52548 19 4.2965 18.9188 4.10754C18.8473 3.94087 18.7317 3.7968 18.5845 3.69078C18.4177 3.57057 18.1942 3.52089 17.7471 3.42155L10.3471 1.7771C10.2176 1.74832 10.1528 1.73393 10.0874 1.72819C10.0292 1.72309 9.97077 1.72309 9.91264 1.72819C9.8472 1.73393 9.78244 1.74832 9.65291 1.7771Z",
    stroke: "#4657F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchIcon);
export default __webpack_public_path__ + "static/media/achIcon.fe4de53f3fc5122e97b14c10a8606d0b.svg";
export { ForwardRef as ReactComponent };